<vw-toast-popup
  [isOpen]="isOpen"
  width="100%"
  borderRadius="20px"
  customClass="bg-white"
  (close)="onClose()"
>
  <div class="px-4 pb-2">
    <h2 class="pb-1 text-2xl font-semibold text-[#062825]">
      {{ "premium.manage.title" | translate }}
    </h2>

    @if (state?.isPremium) {
      <!-- Statut : plan et jusqu'a quand l'acces est ouvert -->
      <div class="mb-4 rounded-2xl bg-[#F2FAF5] px-4 py-3">
        <p class="text-sm font-medium text-[#062825]">
          {{
            (state?.plan === "YEARLY"
              ? "premium.paywall.yearly"
              : "premium.paywall.monthly"
            ) | translate
          }}
        </p>
        <p class="text-sm text-[#317756]">{{ statusLabel }}</p>
        @if (state?.status === "PAST_DUE") {
          <p class="mt-1 text-xs text-[#A9773A]">
            {{ "premium.manage.past-due" | translate }}
          </p>
        }
      </div>
    }

    @if (confirmingCancel) {
      <!-- Le message dit exactement jusqu'a quand l'acces reste ouvert -->
      <div class="mb-4 rounded-2xl border border-[#E3E8E5] px-4 py-4">
        <p class="pb-1 text-base font-semibold text-[#062825]">
          {{ "premium.manage.cancel-confirm-title" | translate }}
        </p>
        <p class="pb-4 text-sm text-[#6E7B75]">{{ cancelConfirmMessage }}</p>
        <div class="flex gap-3">
          <vw-button
            look="clear"
            [label]="'premium.manage.cancel-yes' | translate"
            [loading]="loading"
            customClass="flex-1"
            (click)="confirmCancel()"
          />
          <vw-button
            look="primary"
            [label]="'premium.manage.cancel-no' | translate"
            customClass="flex-1"
            (click)="confirmingCancel = false"
          />
        </div>
      </div>
    } @else {
      @if (isCanceled) {
        <vw-button
          look="primary"
          [label]="'premium.manage.reactivate' | translate"
          [loading]="loading"
          customClass="w-full"
          (click)="reactivate()"
        />
      }

      @if (isStripe) {
        <button
          type="button"
          (click)="openBilling()"
          class="mt-3 flex w-full items-center justify-between rounded-2xl border border-[#E3E8E5] px-4 py-3 text-left"
        >
          <span class="text-sm text-[#062825]">{{
            "premium.manage.billing" | translate
          }}</span>
          <svg
            class="h-4 w-4 text-[#9BA6A1]"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 01-1 1H5a1 1 0 01-1-1V7a1 1 0 011-1h5"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      }

      @if (!isCanceled) {
        <!-- Ouvert à TOUS les canaux : un essai ou des mois offerts doivent
             aussi pouvoir être arrêtés. Le refuser laissait un écran de
             gestion sans aucune sortie. -->
        <button
          type="button"
          (click)="confirmingCancel = true"
          class="mt-3 w-full py-2 text-center text-sm text-[#E61A27]"
        >
          {{ cancelLabel | translate }}
        </button>
      }

      @if (!isStripe && state?.isPremium) {
        <!-- Essai ou mois offerts : rien à annuler, l'échéance fait foi.
             Le libellé ne dit PAS « Passer Premium » : la personne l'est déjà,
             et le lui proposer donne l'impression que son accès ne compte pas.
             Ce qu'on lui offre, c'est de prolonger au-delà de l'échéance. -->
        <vw-button
          look="primary"
          [label]="'premium.manage.subscribe-now' | translate"
          customClass="w-full mt-2"
          (click)="onClose({ upgrade: true })"
        />
      }
    }

    @if (error) {
      <p class="mt-2 text-center text-sm text-[#E61A27]">
        {{ "common.error" | translate }}
      </p>
    }
  </div>
</vw-toast-popup>
